import React, { useState } from 'react';
import { Container, Row, Col, Card, Form, Button, Alert, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ApiActions } from '../shared/apiActions';
import apiCall from '../shared/apiCall';
import VersionFooter from '../components/VersionFooter';

export default function ForgotPassword() {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setMessage('');

    try {
      const response = await apiCall(
        `/api/set?action=${ApiActions.REQUEST_PASSWORD_RESET}`,
        { email },
        'POST'
      );

      if (response.success) {
        // Use messageCode for translation, fallback to message or translation key
        if (response.messageCode === 'RESET_LINK_SENT') {
          setMessage(t('auth.resetLinkSent'));
        } else {
          setMessage(response.message || t('auth.resetLinkSent'));
        }
      } else {
        setError(response.message || t('auth.failedToSendResetEmail'));
      }
    } catch (err) {
      console.error('Error:', err);
      setError(t('auth.errorOccurred'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Container className="py-5">
      <Row className="justify-content-center">
        <Col md={6} lg={5}>
          <Card className="shadow">
            <Card.Body className="p-4">
              <div className="text-center mb-4">
                <i className="bi bi-key fs-1 text-primary mb-3"></i>
                <h2 className="mb-2">{t('auth.forgotPasswordTitle')}</h2>
                <p className="text-muted">
                  {t('auth.forgotPasswordDescription')}
                </p>
              </div>

              {error && <Alert variant="danger">{error}</Alert>}
              {message && <Alert variant="success">{message}</Alert>}

              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label>{t('auth.emailAddress')}</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder={t('auth.enterEmail')}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    disabled={loading || !!message}
                  />
                </Form.Group>

                <div className="d-grid gap-2 mb-3">
                  <Button 
                    variant="primary" 
                    type="submit" 
                    disabled={loading || !!message}
                  >
                    {loading ? (
                      <>
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                          className="me-2"
                        />
                        {t('auth.sending')}
                      </>
                    ) : t('auth.sendResetLink')}
                  </Button>
                </div>

                <div className="text-center">
                  <Button 
                    variant="link" 
                    className="text-decoration-none"
                    onClick={() => navigate('/')}
                  >
                    <i className="bi bi-arrow-left me-1"></i>{t('auth.backToLogin')}
                  </Button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
    
    <VersionFooter />
  </>
  );
}

